import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IContactInformation } from "../../models/ContactInformation";
import { ContactInformationService } from "../../services/contactInformation.service";

export const useGetContactInformationQuery = (userId: string | null) => {
  return useQuery<IContactInformation, Error>({
    queryKey: [QUERY_CONSTANTS.GET_CONTACT_INFORMATION, userId],
    queryFn: () => ContactInformationService.getByUserId(userId).then((res) => res.data),
    enabled: !!userId,
  });
};
